import { Dispatch, SetStateAction } from 'react';
import { SetError } from '../../redux/modals';

export const Platform = {
  LINEAR: 'Linear',
  STREAMING: 'Streaming'
} as const;
export type PlatformType = (typeof Platform)[keyof typeof Platform];

export interface AdOpsUtilFunctions {
  setError: SetError;
  setModalMessage: Dispatch<SetStateAction<string>>;
  setShowModalConfirmation: Dispatch<SetStateAction<boolean>>;
}

export interface AdOpsToolProps {
  utils: AdOpsUtilFunctions;
}

// The `/derived` lambda either returns the derived-network map inline or, when the payload is
// large, a redirect pointing at an S3 object. Both are JSON objects, so narrow on the `url` field.
export const isS3Redirect = (value: unknown): value is { url: string } =>
  typeof value === 'object' && value !== null && 'url' in value && typeof value.url === 'string';
